import { get } from 'lodash'

export const isAuthentified = state =>
  !get(state.auth.currentUser, 'isAnonymous', true)

export const isAdmin = state => get(state.auth, 'profile.isAdmin', false)

export const currentUser = state => state.auth.currentUser

export const currentUserUid = state => state.auth.currentUser.uid

export const checkAuth = state => state.auth.checkAuth



// WEBPACK FOOTER //
// ./src/selectors/auth.js